import { render } from "./FamilyMembersDetailsModal.vue?vue&type=template&id=f505bb38"
import script from "./FamilyMembersDetailsModal.vue?vue&type=script&lang=js"
export * from "./FamilyMembersDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__